import {Base} from "@/api/Base"

export class CurrencyEdit extends Base {
    path = "currency/edit"
}